import React, { useState, useEffect, useRef } from 'react';
import './Hero.css';
import VideoModal from '../VideoModal/VideoModal';
import { Link } from 'react-router-dom'; // UPDATED: 1. Import Link from react-router-dom

// Import all three images for our slides
import imageSlide1 from '../../assets/images/laptoptab-logo.png';
import imageSlide2 from '../../assets/images/aga_visualization.png';
import imageSlide3 from '../../assets/images/aga_lens.jpg';

import brochurePDF from '../../assets/brochures/crishi-brochure.pdf';


// Array containing the content for each slide
const slides = [
  {
    title: "CRISHI is your trusted platform for crop research, data and consulting.",
    image: imageSlide1,
    buttons: [
        { text: "Watch video", type: "primary", action: "openModal" },
        // UPDATED: 2. Added a 'link' property for navigation
        { text: "Book a demo", type: "secondary", link: "/signup" }
    ]
  },
  {
    title: "Benchmark confidently with CRISHI indices.",
    subtitle: "Skip the time and cost of discovering prices on your own. Our verified indices offer timely, credible market signals for smarter pricing and planning.",
    image: imageSlide2,
    buttons: [
        { text: "Explore price indices", type: "primary", link: "/prices" }
    ]
  },
  {
    title: "AGRIFOOD NEXTGEN BUSINESS LEADERS SUMMIT 12th & 13th December 2025",
    image: imageSlide3,
    buttons: [
        { text: "Register now", type: "primary", link:"https://www.teflas.com/fc.pdf" },
        { text: "Download brochure", type: "secondary", href: brochurePDF }
    ]
  }
];


const Hero = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const timeoutRef = useRef(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const videoId = '2ZL-0qLlrtw?si=3jTABDnbEW5XFd5w';


  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setActiveIndex((prevIndex) =>
          prevIndex === slides.length - 1 ? 0 : prevIndex + 1
        ),
      5000
    );
    return () => {
      resetTimeout();
    };
  }, [activeIndex]);

  const goToSlide = (slideIndex) => {
    setActiveIndex(slideIndex);
  };
  
  const handleButtonClick = (action) => {
    if (action === 'openModal') {
      setModalOpen(true);
    }
  };

  return (
    <>
      <div className="hero-slider">
        <div className="slides-wrapper" style={{ transform: `translateX(-${activeIndex * 100}%)` }}>
          {slides.map((slide, index) => (
            <div className="slide" key={index}>
              <div className="hero-content">
                <h1>{slide.title}</h1>
                {slide.subtitle && <p className="subtitle">{slide.subtitle}</p>}
                <div className="hero-buttons">
                  
                  {/* UPDATED: 3. This whole block is changed for conditional rendering */}
                   {slide.buttons.map((button, btnIndex) => {
                    // Check for 'href' FIRST for direct file/external links
                     if (button.href) {
                      return (
                        <a href={button.href} key={btnIndex} target="_blank" rel="noopener noreferrer" className="hero-button-link">
                          <button className={button.type === 'primary' ? 'watch-video-btn' : 'book-demo-btn'}>{button.text}</button>
                        </a>
                      );
                    }
                    if (button.link) {
                      return (
                        <Link to={button.link} key={btnIndex}>
                          <button className={button.type === 'primary' ? 'watch-video-btn' : 'book-demo-btn'}>
                            {button.text}
                          </button>
                        </Link>
                      );
                    }
                    // Otherwise, render a regular button with an onClick handler
                    return (
                      <button 
                        key={btnIndex} 
                        className={button.type === 'primary' ? 'watch-video-btn' : 'book-demo-btn'}
                        onClick={() => handleButtonClick(button.action)} 
                      >
                        {button.text}
                      </button>
                    );
                  })}
                </div>
              </div>
              <div className="hero-image-container">
                <img src={slide.image} alt={`Slide ${index + 1}`} />
              </div>
            </div>
          ))}
        </div>

        <div className="pagination-dots">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`dot ${activeIndex === index ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            ></button>
          ))}
        </div>
      </div>
      
      <VideoModal 
        show={isModalOpen} 
        onClose={() => setModalOpen(false)}
        videoId={videoId}
      />
    </>
  );
};

export default Hero;